import React, { useRef, useState } from "react"

import { useTranslation } from "react-i18next";
import AutoCompletation from "../../../components/Common/AutoCompletation";
import { FormGroup } from 'react-bootstrap'
import InventoryMedicationService from "../../../api/Inventory/InventoryMedicationService";
import { ErrorMessage } from "../../../components/Notifications/Notifications";
import { AssignmentType } from "../../../api/Inventory/Entities/InventoryEntities";
import { buildMedicationLabelWithStock, isDispenseAddEnabled } from "./inventoryFormRules";
import { QuantityInput } from "./QuantityInput";

export default function MedicationDispenseForm({ assignmentType, assignId, handleSubmit, disabled = false }) {
    const { t } = useTranslation();
    const quantityRef = useRef();
    const medicationRef = useRef();;
    const [selectedItem, setSelectedItem] = useState(null);
    const [quantity, setQuantity] = useState(1);

    const fetchItems = async (term) => {
        const result = await InventoryMedicationService.Find({ term: term, onlyLocal: true, pageSize: 100, includePharmacyStock: true })
        return result.Value
    }

    const curringSelected = (callback) => {
        return (selected) => {
            if (selected != null && selected.length > 0) callback(selected[0])
            else callback(null)
        }
    }

    function isFormValid() {
        return isDispenseAddEnabled({
            hasItem: selectedItem !== null,
            hasRelease: true,
            quantity: quantity,
            availableStock: selectedItem?.stockQuantity
        })
    }
    function handleItemClean() {
        setSelectedItem(null)
        setQuantity(1)
        medicationRef.current.clear()
    }

    function handleFormSubmit(e) {
        e.preventDefault();

        if (!isFormValid() && handleSubmit !== null) return

        if (selectedItem.stockQuantity < quantity) {
            ErrorMessage(t('inventory.dispense.errors.cannotOvercomeTheStockQuantity'))
            return;
        }

        handleSubmit({
            item: selectedItem,
            release: null,
            assignment: {
                assignmentType: AssignmentType.General.Name
            },
            quantity: quantity,
            availableQuantity: selectedItem.stockQuantity
        })
        handleItemClean()
        medicationRef.current.focus()
    }

    return (<>
        <form onSubmit={handleFormSubmit} autoComplete="off">
            <div className='input-group-container'>
                <FormGroup style={{ width: "100%" }}>
                    <AutoCompletation
                        id={'medication'}
                        ref={medicationRef}
                        labelKey={(option) => buildMedicationLabelWithStock(option)}
                        placeholder={t('inventory.dispense.findMedication')}
                        disabled={disabled}
                        fetchOptions={fetchItems}
                        onChange={curringSelected(setSelectedItem)}
                        onNext={() => quantityRef.current.focus()}
                    />
                </FormGroup>
            </div>
            <hr />
            <div style={{ display: "flex", justifyContent: 'end' }} >
                <div style={{ display: 'flex', flexDirection: "column", width: "25%", marginRight: '1rem' }}>
                    <QuantityInput ref={quantityRef}
                        value={quantity}
                        onChange={setQuantity}
                        max={selectedItem?.stockQuantity}
                        disabled={disabled || selectedItem == null}
                        placeholder={t('inventory.dispense.quantity')} />
                </div>
                <div style={{ alignSelf: 'self-end' }}>
                    <button type="submit" className='btn btn-success' disabled={disabled || !isFormValid()}>{t('buttons.add')}</button>
                </div>
            </div>
        </form>
    </>)
}